import { SdkEventInterface } from "@modules/sdk/events/SdkEventInterface";

import { COMMON_SDK_EVENTS } from "../constants";

class WidgetClosedSdkEvent implements SdkEventInterface {
    public readonly type = COMMON_SDK_EVENTS.WIDGET_CLOSED;
    public readonly widgetName: string;

    constructor(widgetName: string) {
        this.widgetName = widgetName;
    }
}

export default WidgetClosedSdkEvent;
